import { Bike, Car } from "lucide-react";
import { useZone } from "../context/ZoneContext";
import { useAuth } from "../context/AuthContext";
import { isNoldDomain } from "./domain";

// Identité dynamique selon la zone (Frontend uniquement).
// Europe -> "Nold Go" + icône voiture ; Afrique -> "BentSkin Go" + icône moto.
// Priorité : zone du compte utilisateur > zone mémorisée (bsg_zone) / IP.
export function useBrand() {
  const { zone } = useZone();
  const { user } = useAuth();
  const lsZone = typeof localStorage !== "undefined" ? localStorage.getItem("bsg_zone") : null;
  // Domaine noldgo.com → identité Nold Go FORCÉE (prioritaire sur la zone IP/compte).
  const isEurope = isNoldDomain() ? true : (user?.zone ? user.zone === "europe" : (zone === "europe" || lsZone === "europe"));
  return {
    isEurope,
    name: isEurope ? "Nold Go" : "BentSkin Go",
    firstWord: isEurope ? "Nold" : "BentSkin",
    Icon: isEurope ? Car : Bike,
  };
}
